import {HintVariant} from 'src/components/Hint/index'

export enum SpeedBumpType {
  genericConfirm = 'genericConfirm',
  genericSuccess = 'genericSuccess',
  rescheduleFailedJobs = 'rescheduleFailedJobs',
  bulkEditForAllUrls = 'bulkEditForAllUrls'
}

const defaultSpeedBumpState = {
  show: false,
  type: <SpeedBumpType|undefined> undefined,
  variant: <HintVariant|undefined> undefined,
  title: '',
  body: '',
}

export type SpeedBumpStateType = typeof defaultSpeedBumpState

export default defaultSpeedBumpState
